import { appApi } from "@/services/api";

export async function registerUserAccess() {
	await appApi.post("/userauditlog/register-user-access");
}
